/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';

// add dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { addTicket, getTickets } from '../../../db/TicketRequestHandler';
import store from '../../../components/stores/Store';
import { getIfFuncAuthorized } from '../../../utils/CheckSomething';
import CheckHandler from '../../../utils/CheckHandler';
import ITextField from '../../../components/UI/ITextField';


const styles = {
  root: {
  },
  textField: {
    width: '15ch',
  },
  formControl: {
    margin: '10px',
    // width: '20ch',
    minWidth: '20ch',
  },
  rootform: {
    marginTop: '10px',
    textAlign: 'left',
  },
  button: {
    marginLeft: '10px',
    marginTop: '10px',
  }
};
// NavigateLeft
class SelectionOfRoomTicketInfoManagementInner extends Component {
  constructor() {
    super();
    store.setSelections({
      subarea: '',
      ticketNo: '',
      state: '',
      purchaseStatus: '',
      ticketHolder: '',
      mobileNumber: '',
      buyer: '',
      mobileNumber2: '',
    });
    this.state = {
      addTicketDialogOpen: false,
      createTicketParams: {
        subarea: '',
        ticketNo: '',
        ticketHolder: '',
        mobileNumber: '',
        idCard: '',
        buyer: '',
        mobileNumber2: '',
        idCard2: '',
        relationship: '',
        state: '',
        purchaseStatus: '',
        validPeriod: '',
        remarks: '',
        ticketAmount: '',
        startDate: '',
        endDate: '',
        judicialAnnex: ',', // 司法附件
        createby: '',
        createdate: '',
        updateby: '',
        updatedate: '',
        marketId: '',
      },
      dialogMsg: '',
    };
    this.addTicket = this.addTicket.bind(this);
    this.onTicketDialogChange = this.onTicketDialogChange.bind(this);
    this.search = this.search.bind(this);
    this.importExcel = this.importExcel.bind(this);
    this.exportExcel = this.exportExcel.bind(this);
  }

  async componentDidMount() {
    store.iniPage();
    this.search();
    store.search = this.search;
  }
  componentWillUnmount() { }

  async addTicket() {
    const subarea = this.state.createTicketParams.subarea.trim();
    const ticketNo = this.state.createTicketParams.ticketNo.trim();
    const ticketAmount = this.state.createTicketParams.ticketAmount.trim();
    const ticketHolder = this.state.createTicketParams.ticketHolder.trim();
    const mobileNumber = this.state.createTicketParams.mobileNumber.trim();
    const idCard = this.state.createTicketParams.idCard.trim();
    const buyer = this.state.createTicketParams.buyer.trim();
    const mobileNumber2 = this.state.createTicketParams.mobileNumber2.trim();
    const idCard2 = this.state.createTicketParams.idCard2.trim();
    const relationship = this.state.createTicketParams.relationship.trim();
    const startDate = this.state.createTicketParams.startDate.trim();
    const endDate = this.state.createTicketParams.endDate.trim();
    const remarks = (this.state.createTicketParams.remarks || '').trim();

    const chkRst = CheckHandler.checkParams([
      { key: '区域', value: subarea, notNull: false, type: '', maxLength: 20 },
      { key: '票号', value: ticketNo, notNull: true, type: 'int', maxLength: 16 },
      { key: '余额', value: ticketAmount, notNull: true, type: 'number', maxLength: 10 },
      { key: '被搬迁户', value: ticketHolder, notNull: true, type: '', maxLength: 10 },
      { key: '被搬迁户手机号', value: mobileNumber, notNull: true, type: 'phone', maxLength: 11 },
      { key: '被搬迁户身份证号码', value: idCard, notNull: true, type: 'idnum', maxLength: 18 },
      { key: '房票使用人', value: buyer, notNull: true, type: '', maxLength: 10 },
      { key: '房票使用人手机号', value: mobileNumber2, notNull: true, type: 'phone', maxLength: 11 },
      { key: '房票使用人身份证号码', value: idCard2, notNull: true, type: 'idnum', maxLength: 18 },
      { key: '被搬迁户与房票使用人关系', value: relationship, notNull: true, type: '', maxLength: 10 },
      { key: '开始日期', value: startDate, notNull: true, type: '', maxLength: 10 },
      { key: '结束日期', value: endDate, notNull: true, type: '', maxLength: 10 },
      { key: '备注', value: remarks, notNull: false, type: '', maxLength: 20 },
    ]);
    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    const rst = await addTicket({
      subarea, ticketNo, ticketAmount, ticketHolder,
      mobileNumber, idCard, buyer, mobileNumber2,
      idCard2, relationship, startDate, endDate, remarks
    });
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '添加房票错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- addTicket rst: `, rst);
      store.setSelections({
        ticketNo: '',
        state: '',
        purchaseStatus: '',
        ticketHolder: '',
        mobileNumber: '',
        buyer: '',
        mobileNumber2: '',
      });
      store.openMessageDialogOpen(rst.msg || '添加房票成功');
      this.setState({
        addTicketDialogOpen: false,
        createTicketParams: {
          subarea: '',
          ticketNo: '',
          ticketHolder: '',
          mobileNumber: '',
          idCard: '',
          buyer: '',
          mobileNumber2: '',
          idCard2: '',
          relationship: '',
          state: '',
          purchaseStatus: '',
          validPeriod: '',
          remarks: '',
          ticketAmount: '',
          startDate: '',
          endDate: '',
          judicialAnnex: ',', // 司法附件
          createby: '',
          createdate: '',
          updateby: '',
          updatedate: '',
          marketId: '',
        },
       });
      this.search();
      return true;
    }
  }

  onTicketDialogChange(e, prop) {
    e.stopPropagation();
    const newCreateTicketParams = this.state.createTicketParams;
    newCreateTicketParams[prop] = e.target.value;
    this.setState({ createTicketParams: newCreateTicketParams });
  }

  async search() {
    if (!getIfFuncAuthorized('房票管理-房票信息管理-查找')) {
      store.openMessageDialogOpen('权限不足');
      return;
    }
    const selections = {
      ticketNo: ['like', store.selections.ticketNo],
      state: ['equal', store.selections.state],
      purchaseStatus: ['equal', store.selections.purchaseStatus],
      ticketHolder: ['like', store.selections.ticketHolder],
      mobileNumber: ['like', store.selections.mobileNumber],
      buyer: ['like', store.selections.buyer],
      mobileNumber2: ['like', store.selections.mobileNumber2],
    };
    console.log('----- 搜索：', selections);
    const rst = await getTickets({
      where: selections,
      orderBy: store.tableConfig.orderBy || "ticketNo",
      order: store.tableConfig.order || 'DESC',
      currentPage: store.tableConfig.currentPage, // 当前页
      rowsPerPage: store.tableConfig.rowsPerPage, // 每页条数
    });

    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '查询错误');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- search rst: `, rst);
      store.setTable(rst.data);
      store.setTableCount(rst.count || 0);
      return true;
    }
  }

  importExcel() {
    // 读取文件

    // 从excel转换成结构体

    // 插表
  }

  exportExcel() {
    // 从服务器读取

    // 从结构体转换成excel

    // 保存文件
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <form className={classes.rootform} noValidate autoComplete="off">
          {(getIfFuncAuthorized('房票管理-房票信息管理-添加')) && (
            <Button color="primary" variant="contained" aria-label="contained primary button group"
              className={classes.button}
              onClick={e => this.setState({ addTicketDialogOpen: true })}
            >
              添加
            </Button>
          )}
          <Button color="primary" variant="contained" aria-label="contained primary button group"
            className={classes.button}
            onClick={this.search}
          >
            刷新
          </Button>

          {(false && getIfFuncAuthorized('房票管理-房票信息管理-下载模板')) && (
            <Button color="primary" variant="contained" aria-label="contained primary button group"
              className={classes.button}
            >
              下载模板
            </Button>
          )}
          {(false && getIfFuncAuthorized('房票管理-房票信息管理-导出Excel')) && (
            <Button color="primary" variant="contained" aria-label="contained primary button group"
              className={classes.button}
              onClick={this.exportExcel}
            >
              导出Excel
            </Button>
          )}
          {(false && getIfFuncAuthorized('房票管理-房票信息管理-Excel导入')) && (
            <Button color="primary" variant="contained" aria-label="contained primary button group"
              className={classes.button}
              onClick={this.importExcel}
            >
              导入Excel
            </Button>
          )}
        </form>
        <form className={classes.rootform} noValidate autoComplete="off">
          <TextField
            id="outlined-number"
            label="区域"
            type="text"
            variant="outlined"
            margin="dense"
            value={store.selections.subarea || ''}
            onChange={e => store.onChangeSelection(e, 'subarea')}
            className={classes.textField}
          />
          <TextField
            id="outlined-number"
            label="票号"
            type="text"
            variant="outlined"
            value={store.selections.ticketNo || ''}
            onChange={e => store.onChangeSelection(e, 'ticketNo')}
            margin="dense"
            className={classes.textField}
          />
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="demo-simple-select-outlined-label" style={{ marginTop: '-8px' }}>状态</InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              label="状态"
              value={store.selections.state || ''}
              onChange={e => store.onChangeSelection(e, 'state')}
              margin="dense"
            >
              <MenuItem value=''>
                <em>请选择</em>
              </MenuItem>
              <MenuItem value={'1'}>未生效</MenuItem>
              <MenuItem value={'2'}>已生效</MenuItem>
            </Select>
          </FormControl>


          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel
              id="demo-simple-select-outlined-label"
              style={{ marginTop: '-8px' }}
            >
              购房状态
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={store.selections.purchaseStatus || ''}
              onChange={e => store.onChangeSelection(e, 'purchaseStatus')}
              label="购房状态"
              margin="dense"
            >
              <MenuItem value="">
                <em>请选择</em>
              </MenuItem>
              <MenuItem value={'1'}>未购房</MenuItem>
              <MenuItem value={'2'}>已购房</MenuItem>
            </Select>
          </FormControl>

          <TextField
            id="outlined-number"
            label="被搬迁户姓名"
            type="text"
            variant="outlined"
            margin="dense"
            value={store.selections.ticketHolder || ''}
            onChange={e => store.onChangeSelection(e, 'ticketHolder')}
            className={classes.textField}
          />
          <TextField
            id="outlined-number"
            label="被搬迁户手机号"
            type="text"
            variant="outlined"
            value={store.selections.mobileNumber || ''}
            onChange={e => store.onChangeSelection(e, 'mobileNumber')}
            margin="dense"
            className={classes.textField}
          />
          <TextField
            id="outlined-number"
            label="房票使用人姓名"
            type="text"
            value={store.selections.buyer || ''}
            onChange={e => store.onChangeSelection(e, 'buyer')}
            variant="outlined"
            margin="dense"
            className={classes.textField}
          />
          <TextField
            id="outlined-number"
            label="房票使用人手机号"
            type="text"
            variant="outlined"
            value={store.selections.mobileNumber2 || ''}
            onChange={e => store.onChangeSelection(e, 'mobileNumber2')}
            margin="dense"
            className={classes.textField}
          />
          <Button color="primary" variant="contained" aria-label="contained primary button group" className={classes.button} onClick={this.search}>搜索</Button>
          <Button color="primary" variant="contained" aria-label="contained primary button group"
            onClick={e => store.clearSelection()}
            className={classes.button}>
            清除搜索
          </Button>
        </form>

        <Dialog
          open={this.state.addTicketDialogOpen}
          id='addTicketDialog' onClose={e => this.setState({ addTicketDialogOpen: false })} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">添加房票</DialogTitle>
          <DialogContent>
            <ITextField
                margin="dense"
                id="subarea"
                label="区域（非必输）"
                fullWidth

                ivalue={this.state.createTicketParams.subarea}
                onChange={e => this.onTicketDialogChange(e, 'subarea')}
                type=""
                maxLength='20'
              />
            <ITextField
              autoFocus
              margin="dense"
              id="ticketNo"
              label="*票号"
              fullWidth

              ivalue={this.state.createTicketParams.ticketNo}
              onChange={e => this.onTicketDialogChange(e, 'ticketNo')}
              type="int"
              maxLength='20'
              notNull
            />
            <ITextField
              margin="dense"
              id="ticketHolder"
              label="*被搬迁户"
              fullWidth

              ivalue={this.state.createTicketParams.ticketHolder}
              onChange={e => this.onTicketDialogChange(e, 'ticketHolder')}
              type=""
              maxLength='20'
              notNull
            />
            <ITextField
              margin="dense"
              id="mobileNumber"
              label="*被搬迁户手机号"
              fullWidth

              ivalue={this.state.createTicketParams.mobileNumber}
              onChange={e => this.onTicketDialogChange(e, 'mobileNumber')}
              type="phone"
              maxLength='11'
              notNull
            />
            <ITextField
              margin="dense"
              id="idCard"
              label="*被搬迁户身份证号码"
              fullWidth

              ivalue={this.state.createTicketParams.idCard}
              onChange={e => this.onTicketDialogChange(e, 'idCard')}
              type="idnum"
              maxLength='18'
              notNull
            />
            <ITextField
              margin="dense"
              id="buyer"
              label="*房票使用人"
              fullWidth

              ivalue={this.state.createTicketParams.buyer}
              onChange={e => this.onTicketDialogChange(e, 'buyer')}
              type=""
              maxLength='20'
              notNull
            />
            <ITextField
              margin="dense"
              id="mobileNumber2"
              label="*房票使用人手机号"
              fullWidth

              ivalue={this.state.createTicketParams.mobileNumber2}
              onChange={e => this.onTicketDialogChange(e, 'mobileNumber2')}
              type="phone"
              maxLength='11'
              notNull
            />
            <ITextField
              margin="dense"
              id="idCard2"
              label="*房票使用人身份证号码"
              fullWidth

              ivalue={this.state.createTicketParams.idCard2}
              onChange={e => this.onTicketDialogChange(e, 'idCard2')}
              type="idnum"
              maxLength='18'
              notNull
            />
            <ITextField
              margin="dense"
              id="relationship"
              label="*被搬迁户与房票使用人关系"
              fullWidth

              ivalue={this.state.createTicketParams.relationship}
              onChange={e => this.onTicketDialogChange(e, 'relationship')}
              type=""
              maxLength='20'
              notNull
            />
            <ITextField
              margin="dense"
              id="ticketAmount"
              label="*余额"
              fullWidth

              ivalue={this.state.createTicketParams.ticketAmount}
              onChange={e => this.onTicketDialogChange(e, 'ticketAmount')}
              type="number"
              maxLength='10'
              notNull
            />
            <ITextField
              margin="dense"
              id="startDate"
              label="*房票有效期-开始日期"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              className={classes.dateField}

              ivalue={this.state.createTicketParams.startDate}
              onChange={e => this.onTicketDialogChange(e, 'startDate')}
              type="date"
              maxLength='10'
              notNull
            />
            <ITextField
              margin="dense"
              id="endDate"
              label="*房票有效期-结束日期"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              className={classes.dateField}

              ivalue={this.state.createTicketParams.endDate}
              onChange={e => this.onTicketDialogChange(e, 'endDate')}
              type="date"
              maxLength='10'
              notNull
            />
            <ITextField
              margin="dense"
              id="remarks"
              label="备注"
              fullWidth

              ivalue={this.state.createTicketParams.remarks}
              onChange={e => this.onTicketDialogChange(e, 'remarks')}
              type=""
              maxLength='20'
              notNull={false}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.addTicket}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              确认添加
            </Button>
            <Button
              onClick={e => this.setState({ addTicketDialogOpen: false })}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const SelectionOfRoomTicketInfoManagement = observer(SelectionOfRoomTicketInfoManagementInner);

SelectionOfRoomTicketInfoManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SelectionOfRoomTicketInfoManagement);
